import { render, staticRenderFns } from "./Pending.vue?vue&type=template&id=3ff241c0&scoped=true"
import script from "./Pending.vue?vue&type=script&lang=js"
export * from "./Pending.vue?vue&type=script&lang=js"
import style0 from "./Pending.vue?vue&type=style&index=0&id=3ff241c0&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ff241c0",
  null
  
)

export default component.exports